export default __webpack_public_path__ + "static/media/Devaramane.7b2016fd.jpg";